// RUT validation and formatting utilities — powered by rut-kit
import { formatRut, validateRut } from 'rut-kit';

/**
 * Formats a RUT input only once it has enough digits to produce a stable
 * formatted value. Re-formatting on every keystroke interferes with backspace
 * (recomputing the DV, reintroducing dashes). Components call this on blur
 * (visual normalization) and again when building the submit body: an
 * Enter-submit skips blur, so the body must not depend on it.
 */
export function formatRutInput(raw) {
  const stripped = raw.replace(/[^0-9kK]/g, '');
  if (!stripped) return '';
  if (stripped.length < 8) return stripped;
  try {
    return formatRut(stripped);
  } catch {
    return stripped;
  }
}

/**
 * Validates a RUT string and returns an error message or null if valid.
 * Defensive against rut-kit throwing (peer-dep load, non-string input).
 */
export function validateRutInput(value) {
  // Same wording as the forms' required-field copy ("requerido").
  if (!value) return 'El RUT es requerido.';
  let result;
  try {
    result = validateRut(value);
  } catch (err) {
    console.error('rut.validate failed', err?.message);
    return 'No se pudo validar el RUT';
  }
  if (!result.valid) {
    return result.error === 'invalidFormat'
      ? 'Formato inválido: escríbelo sin puntos y con guion (ej: 12345678-9)'
      : 'RUT inválido: revisa el dígito verificador';
  }
  return null;
}
